import type { UserRole, UserStatus } from '@psp-aggregator/sdk';
import sdk from '@psp-aggregator/sdk';
import { keepPreviousData } from '@tanstack/react-query';

export interface UseUsersParams {
  enabled?: boolean;
  limit?: number;
  page?: number;
  role?: UserRole;
  search?: string;
  status?: UserStatus;
}

export const useUsers = ({
  enabled = true,
  limit,
  page,
  role,
  search,
  status,
}: UseUsersParams = {}) =>
  sdk.queries.useListUsers(page, limit, status, role, search, {
    enabled,
    placeholderData: keepPreviousData,
  });
